/* ==========================================================================
   VICTORY PATH — vp-scroll.js  (v2)
   Sacred-geometry graphics (Om, Flower of Life, Metatron's Cube, Sri Yantra,
   Lotus, Seed of Life) rendered as pure line-art with a flowing CHAKRA
   gradient stroke and NO background box, so they feel woven into the page.
   Highly interactive "move as you scroll": each symbol scrubs rotation +
   scale + drift + fade, and the whole field reacts to the pointer (parallax).
   Works on the homepage AND every collection page. Graceful, performant
   fallback when GSAP / ScrollTrigger is missing or motion is reduced.
   ========================================================================== */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var UID = 0;
  var CHAKRA = ['#E23E3E', '#F2873E', '#F2D13E', '#57C84D', '#3EA6F2', '#6C5CE7', '#A855E6'];

  function E(t, a) { var e = document.createElementNS(NS, t); if (a) for (var k in a) e.setAttribute(k, a[k]); return e; }

  function svg() {
    var s = E('svg', { viewBox: '-120 -120 240 240', fill: 'none' });
    s.setAttribute('class', 'vp-sym-svg');
    var gid = 'vpg' + (++UID);
    var defs = E('defs');
    var lg = E('linearGradient', { id: gid, x1: '0', y1: '0', x2: '1', y2: '1' });
    for (var i = 0; i < CHAKRA.length; i++) {
      lg.appendChild(E('stop', { offset: (i / (CHAKRA.length - 1)).toFixed(3), 'stop-color': CHAKRA[i] }));
    }
    var anim = E('animateTransform', {
      attributeName: 'gradientTransform', type: 'rotate',
      from: '0 0.5 0.5', to: '360 0.5 0.5', dur: '18s', repeatCount: 'indefinite'
    });
    lg.appendChild(anim);
    defs.appendChild(lg); s.appendChild(defs);
    s._g = 'url(#' + gid + ')';
    return s;
  }
  function circ(s, x, y, r, w, o) { s.appendChild(E('circle', { cx: x, cy: y, r: r, stroke: s._g, 'stroke-width': w || 1, opacity: o == null ? 1 : o })); }
  function line(s, x1, y1, x2, y2, w, o) { s.appendChild(E('line', { x1: x1, y1: y1, x2: x2, y2: y2, stroke: s._g, 'stroke-width': w || 0.5, opacity: o == null ? 0.5 : o })); }
  function path(s, d, w, o) { s.appendChild(E('path', { d: d, stroke: s._g, 'stroke-width': w || 1, opacity: o == null ? 1 : o, fill: 'none', 'stroke-linejoin': 'round' })); }

  function flowerOfLife() {
    var s = svg(), r = 30, P = [[0, 0]], i, a;
    for (i = 0; i < 6; i++) { a = i * Math.PI / 3; P.push([Math.cos(a) * r, Math.sin(a) * r]); }
    for (i = 0; i < 6; i++) { a = i * Math.PI / 3; P.push([Math.cos(a) * 2 * r, Math.sin(a) * 2 * r]); var a2 = a + Math.PI / 6; P.push([Math.cos(a2) * r * 1.732, Math.sin(a2) * r * 1.732]); }
    P.forEach(function (p) { circ(s, p[0], p[1], r, 1.4, 0.95); });
    circ(s, 0, 0, 3 * r, 2, 0.6); circ(s, 0, 0, 3 * r + 7, 1.2, 0.4);
    return s;
  }
  function seedOfLife() {
    var s = svg(), r = 34, i, a;
    circ(s, 0, 0, r, 1.6, 0.95);
    for (i = 0; i < 6; i++) { a = i * Math.PI / 3; circ(s, Math.cos(a) * r, Math.sin(a) * r, r, 1.6, 0.95); }
    circ(s, 0, 0, 2 * r, 1.6, 0.55); circ(s, 0, 0, 2 * r + 8, 1, 0.35);
    return s;
  }
  function metatron() {
    var s = svg(), r = 42, C = [[0, 0]], i, j, a;
    for (i = 0; i < 6; i++) { a = i * Math.PI / 3 - Math.PI / 2; C.push([Math.cos(a) * r, Math.sin(a) * r]); }
    for (i = 0; i < 6; i++) { a = i * Math.PI / 3 - Math.PI / 2; C.push([Math.cos(a) * 2 * r, Math.sin(a) * 2 * r]); }
    for (i = 0; i < C.length; i++) for (j = i + 1; j < C.length; j++) line(s, C[i][0], C[i][1], C[j][0], C[j][1], 0.5, 0.4);
    C.forEach(function (p) { circ(s, p[0], p[1], 13, 1.4, 0.98); });
    return s;
  }
  function sriYantra() {
    var s = svg();
    function tri(sz, up, y) {
      var h = sz * 0.9;
      var d = up
        ? ('M' + (-sz) + ' ' + (h * 0.5 + y) + ' L' + sz + ' ' + (h * 0.5 + y) + ' L0 ' + (-h * 0.5 + y) + ' Z')
        : ('M' + (-sz) + ' ' + (-h * 0.5 + y) + ' L' + sz + ' ' + (-h * 0.5 + y) + ' L0 ' + (h * 0.5 + y) + ' Z');
      path(s, d, 1.2, 0.92);
    }
    [[102, true, 10], [88, false, -8], [74, true, 18], [62, false, -14], [50, true, 10], [40, false, -6]].forEach(function (t) { tri(t[0], t[1], t[2]); });
    circ(s, 0, 0, 112, 1.2, 0.45); circ(s, 0, 0, 118, 1, 0.28);
    s.appendChild(E('circle', { cx: 0, cy: 0, r: 4, fill: s._g }));
    return s;
  }
  function lotus() {
    var s = svg(), n = 12, i;
    for (i = 0; i < n; i++) { var g = E('g', { transform: 'rotate(' + (i * 360 / n) + ')' }); g.appendChild(E('path', { d: 'M0 0 C 22 -40 22 -82 0 -108 C -22 -82 -22 -40 0 0 Z', stroke: s._g, 'stroke-width': 1.2, opacity: 0.9, fill: 'none' })); s.appendChild(g); }
    for (i = 0; i < n; i++) { var g2 = E('g', { transform: 'rotate(' + ((i + 0.5) * 360 / n) + ')' }); g2.appendChild(E('path', { d: 'M0 0 C 14 -28 14 -56 0 -74 C -14 -56 -14 -28 0 0 Z', stroke: s._g, 'stroke-width': 1, opacity: 0.55, fill: 'none' })); s.appendChild(g2); }
    circ(s, 0, 0, 9, 1.4, 0.8);
    return s;
  }
  function om() {
    var s = svg();
    var t = E('text', { x: 0, y: 62, 'text-anchor': 'middle', 'font-size': 214, fill: s._g, stroke: 'none', opacity: 0.96 });
    t.setAttribute('font-family', 'serif'); t.textContent = 'ॐ';
    s.appendChild(t);
    circ(s, 0, 0, 116, 1.2, 0.4); circ(s, 0, 0, 108, 1, 0.25);
    return s;
  }
  var FACT = { flower: flowerOfLife, seed: seedOfLife, metatron: metatron, sri: sriYantra, lotus: lotus, om: om };

  function makeSymbol(kind, cls) {
    var w = document.createElement('div');
    w.className = 'vp-symbol ' + (cls || '');
    w.setAttribute('aria-hidden', 'true');
    w.appendChild(FACT[kind]());
    return w;
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    if (gsap && ST) gsap.registerPlugin(ST);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var parallax = [];

    var MOTION = {
      drift: [{ rotation: -34, scale: 0.82, yPercent: -12 }, { rotation: 34, scale: 1.14, yPercent: 12 }],
      rise: [{ rotation: 26, scale: 1.16, yPercent: 16 }, { rotation: -22, scale: 0.86, yPercent: -16 }],
      swirl: [{ rotation: -70, scale: 0.7, xPercent: -8 }, { rotation: 70, scale: 1.18, xPercent: 8 }],
      bloom: [{ rotation: -18, scale: 0.62 }, { rotation: 18, scale: 1.2 }],
      hero: [{ rotation: -40, scale: 0.9, yPercent: -8 }, { rotation: 40, scale: 1.25, yPercent: 8 }]
    };

    function decorate(host, sec, kind, cls, opts) {
      if (!host) return;
      opts = opts || {};
      var sym = makeSymbol(kind, cls);
      host.appendChild(sym);
      var svgEl = sym.querySelector('svg');
      if (reduce || !gsap) return;

      if (opts.spin) { gsap.to(svgEl, { rotation: '+=360', duration: 110, ease: 'none', repeat: -1 }); }
      if (ST) {
        var m = MOTION[opts.motion || 'drift'];
        gsap.fromTo(svgEl, m[0], {
          rotation: m[1].rotation, scale: m[1].scale,
          yPercent: m[1].yPercent || 0, xPercent: m[1].xPercent || 0,
          ease: 'none',
          scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: 1.1 }
        });
        if (!opts.solid) {
          gsap.fromTo(sym, { opacity: 0 }, {
            opacity: 1, ease: 'none',
            scrollTrigger: { trigger: sec, start: 'top bottom', end: 'top center', scrub: true }
          });
        }
      }
      parallax.push({ el: sym, depth: opts.depth || (22 + Math.random() * 34) });
    }

    function q(sel) { return document.querySelector(sel); }
    function inner(el, sel) { return (el && el.querySelector(sel)) || el; }

    /* ---------------- HOMEPAGE ---------------- */
    var feats = document.querySelectorAll('.featured-collection');
    if (feats[0]) decorate(inner(feats[0], '.container'), feats[0], 'flower', 'vp-sym--bg vp-sym--tl', { motion: 'drift' });
    if (feats[1]) decorate(inner(feats[1], '.container'), feats[1], 'om', 'vp-sym--bg vp-sym--om vp-sym--br', { motion: 'rise' });
    var man = q('.manifesto');
    if (man) decorate(man, man, 'sri', 'vp-sym--bg', { motion: 'swirl' });
    var dig = q('.digital-section');
    if (dig) decorate(inner(dig, '.container'), dig, 'lotus', 'vp-sym--bg', { motion: 'bloom' });
    var news = q('.newsletter');
    if (news) decorate(news, news, 'seed', 'vp-sym--bg vp-sym--small', { motion: 'drift' });

    var bs = q('.brand-story__media-placeholder');
    if (bs) decorate(bs, q('.brand-story'), 'metatron', 'vp-sym--stage', { spin: true, motion: 'drift', solid: true, depth: 16 });

    /* ---------------- COLLECTION PAGES ---------------- */
    var ch = q('.collection-hero');
    if (ch) decorate(ch, ch, 'sri', 'vp-sym--hero', { motion: 'hero', solid: true, depth: 14 });
    var cg = q('.collection-grid-wrap');
    if (cg) {
      decorate(inner(cg, '.container'), cg, 'flower', 'vp-sym--bg vp-sym--tl', { motion: 'drift' });
      decorate(inner(cg, '.container'), cg, 'lotus', 'vp-sym--bg vp-sym--small vp-sym--br', { motion: 'bloom' });
    }
    var firstGrid = q('.products-grid');
    if (firstGrid && !feats[0] && !cg) {
      var sect = firstGrid.closest('section') || firstGrid.parentElement;
      decorate(sect, sect, 'seed', 'vp-sym--bg', { motion: 'rise' });
    }

    /* ---------------- POINTER PARALLAX FIELD ---------------- */
    if (!reduce && gsap && parallax.length) {
      parallax.forEach(function (p) {
        p.qx = gsap.quickTo(p.el, 'x', { duration: 0.7, ease: 'power3' });
        p.qy = gsap.quickTo(p.el, 'y', { duration: 0.7, ease: 'power3' });
      });
      var move = function (cx, cy) {
        var nx = (cx / window.innerWidth - 0.5), ny = (cy / window.innerHeight - 0.5);
        for (var i = 0; i < parallax.length; i++) { parallax[i].qx(nx * parallax[i].depth); parallax[i].qy(ny * parallax[i].depth); }
      };
      window.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); }, { passive: true });
      window.addEventListener('deviceorientation', function (e) {
        if (e.gamma == null) return;
        move((e.gamma / 45 + 1) * 0.5 * window.innerWidth, (e.beta / 45 + 1) * 0.5 * window.innerHeight);
      }, { passive: true });
    }

    if (ST) ST.refresh();
  });
})();
